{
    "coordinates": [
        82.8323702198384,
        -42.449729358624325
    ],
    "tooltip": "Sirius Passet",
    "title": "Sirius Passet",
    "country": "Greenland (Denmark)",
    "period": "Cambrian",
    "alt": "TODO"
}
